export const MULTIPLE_DOMAIN_SCAN_REQUEST = 'MULTIPLE_DOMAIN_SCAN_REQUEST';
export const MULTIPLE_DOMAIN_SCAN_SUCCESS = 'MULTIPLE_DOMAIN_SCAN_SUCCESS';
export const MULTIPLE_DOMAIN_SCAN_FAILURE = 'MULTIPLE_DOMAIN_SCAN_FAILURE';
export const MULTIPLE_DOMAIN_SCAN_RESET = 'MULTIPLE_DOMAIN_SCAN_RESET';